import { render, staticRenderFns } from "./creatCdkey.vue?vue&type=template&id=2d08b0bb&scoped=true"
import script from "./creatCdkey.vue?vue&type=script&setup=true&lang=js"
export * from "./creatCdkey.vue?vue&type=script&setup=true&lang=js"
import style0 from "./creatCdkey.vue?vue&type=style&index=0&id=2d08b0bb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d08b0bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d08b0bb')) {
      api.createRecord('2d08b0bb', component.options)
    } else {
      api.reload('2d08b0bb', component.options)
    }
    module.hot.accept("./creatCdkey.vue?vue&type=template&id=2d08b0bb&scoped=true", function () {
      api.rerender('2d08b0bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hotel/cdkey/creatCdkey.vue"
export default component.exports